/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ComparisonRouteImport } from './routes/comparison'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as SubmitTokenRouteImport } from './routes/submit/$token'
import { Route as SettingsCostCodesRouteImport } from './routes/settings/cost-codes'
import { Route as SettingsCompanyRouteImport } from './routes/settings/company'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as JHashRouteImport } from './routes/j.$hash'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects/$projectId/index'
import { Route as ProjectsProjectIdMoneyRouteImport } from './routes/projects/$projectId/money'
import { Route as ProjectsProjectIdJournalRouteImport } from './routes/projects/$projectId/journal'
import { Route as ProjectsProjectIdInboxRouteImport } from './routes/projects/$projectId/inbox'
import { Route as ProjectsProjectIdCostDashboardRouteImport } from './routes/projects/$projectId/cost-dashboard'
import { Route as ProjectsProjectIdCostCodesRouteImport } from './routes/projects/$projectId/cost-codes'
import { Route as ProjectsProjectIdBudgetRouteImport } from './routes/projects/$projectId/budget'
import { Route as ProjectsProjectIdActualsRouteImport } from './routes/projects/$projectId/actuals'
import { Route as ProjectsProjectIdDailyLogsIndexRouteImport } from './routes/projects/$projectId/daily-logs/index'
import { Route as ProjectsProjectIdCommitmentsIndexRouteImport } from './routes/projects/$projectId/commitments/index'
import { Route as ProjectsProjectIdDailyLogsNewRouteImport } from './routes/projects/$projectId/daily-logs/new'
import { Route as ProjectsProjectIdDailyLogsLogIdRouteImport } from './routes/projects/$projectId/daily-logs/$logId'
import { Route as ProjectsProjectIdCommitmentsCommitmentIdRouteImport } from './routes/projects/$projectId/commitments/$commitmentId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ComparisonRoute = ComparisonRouteImport.update({
  id: '/comparison',
  path: '/comparison',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmitTokenRoute = SubmitTokenRouteImport.update({
  id: '/submit/$token',
  path: '/submit/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCostCodesRoute = SettingsCostCodesRouteImport.update({
  id: '/settings/cost-codes',
  path: '/settings/cost-codes',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCompanyRoute = SettingsCompanyRouteImport.update({
  id: '/settings/company',
  path: '/settings/company',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const JHashRoute = JHashRouteImport.update({
  id: '/j/$hash',
  path: '/j/$hash',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdMoneyRoute = ProjectsProjectIdMoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdJournalRoute =
  ProjectsProjectIdJournalRouteImport.update({
    id: '/journal',
    path: '/journal',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdInboxRoute = ProjectsProjectIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdCostDashboardRoute =
  ProjectsProjectIdCostDashboardRouteImport.update({
    id: '/cost-dashboard',
    path: '/cost-dashboard',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdCostCodesRoute =
  ProjectsProjectIdCostCodesRouteImport.update({
    id: '/cost-codes',
    path: '/cost-codes',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdBudgetRoute = ProjectsProjectIdBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const ProjectsProjectIdActualsRoute =
  ProjectsProjectIdActualsRouteImport.update({
    id: '/actuals',
    path: '/actuals',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdDailyLogsIndexRoute =
  ProjectsProjectIdDailyLogsIndexRouteImport.update({
    id: '/daily-logs/',
    path: '/daily-logs/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdCommitmentsIndexRoute =
  ProjectsProjectIdCommitmentsIndexRouteImport.update({
    id: '/commitments/',
    path: '/commitments/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdDailyLogsNewRoute =
  ProjectsProjectIdDailyLogsNewRouteImport.update({
    id: '/daily-logs/new',
    path: '/daily-logs/new',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdDailyLogsLogIdRoute =
  ProjectsProjectIdDailyLogsLogIdRouteImport.update({
    id: '/daily-logs/$logId',
    path: '/daily-logs/$logId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdCommitmentsCommitmentIdRoute =
  ProjectsProjectIdCommitmentsCommitmentIdRouteImport.update({
    id: '/commitments/$commitmentId',
    path: '/commitments/$commitmentId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/comparison': typeof ComparisonRoute
  '/onboarding': typeof OnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$hash': typeof JHashRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/cost-codes': typeof SettingsCostCodesRoute
  '/submit/$token': typeof SubmitTokenRoute
  '/projects': typeof ProjectsIndexRoute
  '/projects/$projectId/actuals': typeof ProjectsProjectIdActualsRoute
  '/projects/$projectId/budget': typeof ProjectsProjectIdBudgetRoute
  '/projects/$projectId/cost-codes': typeof ProjectsProjectIdCostCodesRoute
  '/projects/$projectId/cost-dashboard': typeof ProjectsProjectIdCostDashboardRoute
  '/projects/$projectId/inbox': typeof ProjectsProjectIdInboxRoute
  '/projects/$projectId/journal': typeof ProjectsProjectIdJournalRoute
  '/projects/$projectId/money': typeof ProjectsProjectIdMoneyRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/commitments/$commitmentId': typeof ProjectsProjectIdCommitmentsCommitmentIdRoute
  '/projects/$projectId/daily-logs/$logId': typeof ProjectsProjectIdDailyLogsLogIdRoute
  '/projects/$projectId/daily-logs/new': typeof ProjectsProjectIdDailyLogsNewRoute
  '/projects/$projectId/commitments': typeof ProjectsProjectIdCommitmentsIndexRoute
  '/projects/$projectId/daily-logs': typeof ProjectsProjectIdDailyLogsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/comparison': typeof ComparisonRoute
  '/onboarding': typeof OnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$hash': typeof JHashRoute
  '/projects/new': typeof ProjectsNewRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/cost-codes': typeof SettingsCostCodesRoute
  '/submit/$token': typeof SubmitTokenRoute
  '/projects': typeof ProjectsIndexRoute
  '/projects/$projectId/actuals': typeof ProjectsProjectIdActualsRoute
  '/projects/$projectId/budget': typeof ProjectsProjectIdBudgetRoute
  '/projects/$projectId/cost-codes': typeof ProjectsProjectIdCostCodesRoute
  '/projects/$projectId/cost-dashboard': typeof ProjectsProjectIdCostDashboardRoute
  '/projects/$projectId/inbox': typeof ProjectsProjectIdInboxRoute
  '/projects/$projectId/journal': typeof ProjectsProjectIdJournalRoute
  '/projects/$projectId/money': typeof ProjectsProjectIdMoneyRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/commitments/$commitmentId': typeof ProjectsProjectIdCommitmentsCommitmentIdRoute
  '/projects/$projectId/daily-logs/$logId': typeof ProjectsProjectIdDailyLogsLogIdRoute
  '/projects/$projectId/daily-logs/new': typeof ProjectsProjectIdDailyLogsNewRoute
  '/projects/$projectId/commitments': typeof ProjectsProjectIdCommitmentsIndexRoute
  '/projects/$projectId/daily-logs': typeof ProjectsProjectIdDailyLogsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/comparison': typeof ComparisonRoute
  '/onboarding': typeof OnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/j/$hash': typeof JHashRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/projects/new': typeof ProjectsNewRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/cost-codes': typeof SettingsCostCodesRoute
  '/submit/$token': typeof SubmitTokenRoute
  '/projects/': typeof ProjectsIndexRoute
  '/projects/$projectId/actuals': typeof ProjectsProjectIdActualsRoute
  '/projects/$projectId/budget': typeof ProjectsProjectIdBudgetRoute
  '/projects/$projectId/cost-codes': typeof ProjectsProjectIdCostCodesRoute
  '/projects/$projectId/cost-dashboard': typeof ProjectsProjectIdCostDashboardRoute
  '/projects/$projectId/inbox': typeof ProjectsProjectIdInboxRoute
  '/projects/$projectId/journal': typeof ProjectsProjectIdJournalRoute
  '/projects/$projectId/money': typeof ProjectsProjectIdMoneyRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/commitments/$commitmentId': typeof ProjectsProjectIdCommitmentsCommitmentIdRoute
  '/projects/$projectId/daily-logs/$logId': typeof ProjectsProjectIdDailyLogsLogIdRoute
  '/projects/$projectId/daily-logs/new': typeof ProjectsProjectIdDailyLogsNewRoute
  '/projects/$projectId/commitments/': typeof ProjectsProjectIdCommitmentsIndexRoute
  '/projects/$projectId/daily-logs/': typeof ProjectsProjectIdDailyLogsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/comparison'
    | '/onboarding'
    | '/invite/$token'
    | '/j/$hash'
    | '/projects/$projectId'
    | '/projects/new'
    | '/settings/company'
    | '/settings/cost-codes'
    | '/submit/$token'
    | '/projects'
    | '/projects/$projectId/actuals'
    | '/projects/$projectId/budget'
    | '/projects/$projectId/cost-codes'
    | '/projects/$projectId/cost-dashboard'
    | '/projects/$projectId/inbox'
    | '/projects/$projectId/journal'
    | '/projects/$projectId/money'
    | '/projects/$projectId/'
    | '/projects/$projectId/commitments/$commitmentId'
    | '/projects/$projectId/daily-logs/$logId'
    | '/projects/$projectId/daily-logs/new'
    | '/projects/$projectId/commitments'
    | '/projects/$projectId/daily-logs'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/comparison'
    | '/onboarding'
    | '/invite/$token'
    | '/j/$hash'
    | '/projects/new'
    | '/settings/company'
    | '/settings/cost-codes'
    | '/submit/$token'
    | '/projects'
    | '/projects/$projectId/actuals'
    | '/projects/$projectId/budget'
    | '/projects/$projectId/cost-codes'
    | '/projects/$projectId/cost-dashboard'
    | '/projects/$projectId/inbox'
    | '/projects/$projectId/journal'
    | '/projects/$projectId/money'
    | '/projects/$projectId'
    | '/projects/$projectId/commitments/$commitmentId'
    | '/projects/$projectId/daily-logs/$logId'
    | '/projects/$projectId/daily-logs/new'
    | '/projects/$projectId/commitments'
    | '/projects/$projectId/daily-logs'
  id:
    | '__root__'
    | '/'
    | '/comparison'
    | '/onboarding'
    | '/invite/$token'
    | '/j/$hash'
    | '/projects/$projectId'
    | '/projects/new'
    | '/settings/company'
    | '/settings/cost-codes'
    | '/submit/$token'
    | '/projects/'
    | '/projects/$projectId/actuals'
    | '/projects/$projectId/budget'
    | '/projects/$projectId/cost-codes'
    | '/projects/$projectId/cost-dashboard'
    | '/projects/$projectId/inbox'
    | '/projects/$projectId/journal'
    | '/projects/$projectId/money'
    | '/projects/$projectId/'
    | '/projects/$projectId/commitments/$commitmentId'
    | '/projects/$projectId/daily-logs/$logId'
    | '/projects/$projectId/daily-logs/new'
    | '/projects/$projectId/commitments/'
    | '/projects/$projectId/daily-logs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ComparisonRoute: typeof ComparisonRoute
  OnboardingRoute: typeof OnboardingRoute
  InviteTokenRoute: typeof InviteTokenRoute
  JHashRoute: typeof JHashRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  ProjectsNewRoute: typeof ProjectsNewRoute
  SettingsCompanyRoute: typeof SettingsCompanyRoute
  SettingsCostCodesRoute: typeof SettingsCostCodesRoute
  SubmitTokenRoute: typeof SubmitTokenRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comparison': {
      id: '/comparison'
      path: '/comparison'
      fullPath: '/comparison'
      preLoaderRoute: typeof ComparisonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submit/$token': {
      id: '/submit/$token'
      path: '/submit/$token'
      fullPath: '/submit/$token'
      preLoaderRoute: typeof SubmitTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/cost-codes': {
      id: '/settings/cost-codes'
      path: '/settings/cost-codes'
      fullPath: '/settings/cost-codes'
      preLoaderRoute: typeof SettingsCostCodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/company': {
      id: '/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof SettingsCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/j/$hash': {
      id: '/j/$hash'
      path: '/j/$hash'
      fullPath: '/j/$hash'
      preLoaderRoute: typeof JHashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/money': {
      id: '/projects/$projectId/money'
      path: '/money'
      fullPath: '/projects/$projectId/money'
      preLoaderRoute: typeof ProjectsProjectIdMoneyRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/journal': {
      id: '/projects/$projectId/journal'
      path: '/journal'
      fullPath: '/projects/$projectId/journal'
      preLoaderRoute: typeof ProjectsProjectIdJournalRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/inbox': {
      id: '/projects/$projectId/inbox'
      path: '/inbox'
      fullPath: '/projects/$projectId/inbox'
      preLoaderRoute: typeof ProjectsProjectIdInboxRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/cost-dashboard': {
      id: '/projects/$projectId/cost-dashboard'
      path: '/cost-dashboard'
      fullPath: '/projects/$projectId/cost-dashboard'
      preLoaderRoute: typeof ProjectsProjectIdCostDashboardRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/cost-codes': {
      id: '/projects/$projectId/cost-codes'
      path: '/cost-codes'
      fullPath: '/projects/$projectId/cost-codes'
      preLoaderRoute: typeof ProjectsProjectIdCostCodesRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/budget': {
      id: '/projects/$projectId/budget'
      path: '/budget'
      fullPath: '/projects/$projectId/budget'
      preLoaderRoute: typeof ProjectsProjectIdBudgetRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/actuals': {
      id: '/projects/$projectId/actuals'
      path: '/actuals'
      fullPath: '/projects/$projectId/actuals'
      preLoaderRoute: typeof ProjectsProjectIdActualsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/daily-logs/': {
      id: '/projects/$projectId/daily-logs/'
      path: '/daily-logs'
      fullPath: '/projects/$projectId/daily-logs'
      preLoaderRoute: typeof ProjectsProjectIdDailyLogsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/commitments/': {
      id: '/projects/$projectId/commitments/'
      path: '/commitments'
      fullPath: '/projects/$projectId/commitments'
      preLoaderRoute: typeof ProjectsProjectIdCommitmentsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/daily-logs/new': {
      id: '/projects/$projectId/daily-logs/new'
      path: '/daily-logs/new'
      fullPath: '/projects/$projectId/daily-logs/new'
      preLoaderRoute: typeof ProjectsProjectIdDailyLogsNewRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/daily-logs/$logId': {
      id: '/projects/$projectId/daily-logs/$logId'
      path: '/daily-logs/$logId'
      fullPath: '/projects/$projectId/daily-logs/$logId'
      preLoaderRoute: typeof ProjectsProjectIdDailyLogsLogIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/commitments/$commitmentId': {
      id: '/projects/$projectId/commitments/$commitmentId'
      path: '/commitments/$commitmentId'
      fullPath: '/projects/$projectId/commitments/$commitmentId'
      preLoaderRoute: typeof ProjectsProjectIdCommitmentsCommitmentIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
  }
}

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdActualsRoute: typeof ProjectsProjectIdActualsRoute
  ProjectsProjectIdBudgetRoute: typeof ProjectsProjectIdBudgetRoute
  ProjectsProjectIdCostCodesRoute: typeof ProjectsProjectIdCostCodesRoute
  ProjectsProjectIdCostDashboardRoute: typeof ProjectsProjectIdCostDashboardRoute
  ProjectsProjectIdInboxRoute: typeof ProjectsProjectIdInboxRoute
  ProjectsProjectIdJournalRoute: typeof ProjectsProjectIdJournalRoute
  ProjectsProjectIdMoneyRoute: typeof ProjectsProjectIdMoneyRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  ProjectsProjectIdCommitmentsCommitmentIdRoute: typeof ProjectsProjectIdCommitmentsCommitmentIdRoute
  ProjectsProjectIdDailyLogsLogIdRoute: typeof ProjectsProjectIdDailyLogsLogIdRoute
  ProjectsProjectIdDailyLogsNewRoute: typeof ProjectsProjectIdDailyLogsNewRoute
  ProjectsProjectIdCommitmentsIndexRoute: typeof ProjectsProjectIdCommitmentsIndexRoute
  ProjectsProjectIdDailyLogsIndexRoute: typeof ProjectsProjectIdDailyLogsIndexRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdActualsRoute: ProjectsProjectIdActualsRoute,
  ProjectsProjectIdBudgetRoute: ProjectsProjectIdBudgetRoute,
  ProjectsProjectIdCostCodesRoute: ProjectsProjectIdCostCodesRoute,
  ProjectsProjectIdCostDashboardRoute: ProjectsProjectIdCostDashboardRoute,
  ProjectsProjectIdInboxRoute: ProjectsProjectIdInboxRoute,
  ProjectsProjectIdJournalRoute: ProjectsProjectIdJournalRoute,
  ProjectsProjectIdMoneyRoute: ProjectsProjectIdMoneyRoute,
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
  ProjectsProjectIdCommitmentsCommitmentIdRoute:
    ProjectsProjectIdCommitmentsCommitmentIdRoute,
  ProjectsProjectIdDailyLogsLogIdRoute: ProjectsProjectIdDailyLogsLogIdRoute,
  ProjectsProjectIdDailyLogsNewRoute: ProjectsProjectIdDailyLogsNewRoute,
  ProjectsProjectIdCommitmentsIndexRoute:
    ProjectsProjectIdCommitmentsIndexRoute,
  ProjectsProjectIdDailyLogsIndexRoute: ProjectsProjectIdDailyLogsIndexRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ComparisonRoute: ComparisonRoute,
  OnboardingRoute: OnboardingRoute,
  InviteTokenRoute: InviteTokenRoute,
  JHashRoute: JHashRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  ProjectsNewRoute: ProjectsNewRoute,
  SettingsCompanyRoute: SettingsCompanyRoute,
  SettingsCostCodesRoute: SettingsCostCodesRoute,
  SubmitTokenRoute: SubmitTokenRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
